export default __webpack_public_path__ + "22e3a5c657ea1358957b68dc8383d0ef.png";